<div layout="row" layout-align="center center" class="container">
  <div layout="column" layout-align="center center">
    <mat-icon class="tc-grey-500">info</mat-icon>
    <h3 class="tc-grey-500 ">No info found</h3>
    <span class="tc-grey-500 bold">{{noDataFoundMessage}}</span>
  </div>
</div>
